<template>
  <div>
    <v-dialog v-model="dialog" width="75%">
      <v-card>
        <v-card-title class="mx-3">
          <span class="headline">{{
            $t("MovePositionOrder.StockBatchDialog.loss_title")
          }}</span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("$vuetify.close") }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense align="center">
              <v-col cols="12" sm="5" md="6">
                <SearcherKeyword
                  :label="
                    $t(
                      'MovePositionOrder.StockBatchDialog.stockBatchCodeSearch'
                    )
                  "
                  v-model="seacherStockBatchCodeKeyword"
                  @text="stockBatchCodeKeyword = $event"
                />
              </v-col>
              <v-col cols="12" sm="5" md="4">
                <!-- 状态 -->
                <SearcherStatus
                  v-model="stockBatchStatus"
                  :items="$consts.expiredFlgs"
                  :label="
                    $t(
                      'MovePositionOrder.StockBatchDialog.stockBatchStatusSearch'
                    )
                  "
                />
              </v-col>
            </v-row>
            <v-data-table
              :headers="stockBatchHeaders"
              :items="stockPositionBatchItems"
              :loading="loading"
              multi-sort
              disable-pagination
              hide-default-footer
              class="elevation-0 px-6"
              fixed-header
              height="360px"
              v-model="showSelected"
              show-select
            >
              <template v-slot:item.stock_detail.stock_batch_code="{ item }">
                {{ item.stock_detail.stock_batch_code }}
                <v-chip
                  v-if="item.stock_detail.expired_flg"
                  x-small
                  label
                  :color="item.stock_detail.expired_flg | expiredFlgsColor"
                  :text-color="
                    item.stock_detail.expired_flg | expiredFlgsTextColor
                  "
                >
                  {{ item.stock_detail.expired_flg | expiredFlgsText }}
                </v-chip>

                <v-chip
                  v-if="item.stock_detail.prohibit_flg"
                  small
                  label
                  :color="item.stock_detail.prohibit_flg | prohibitFlgsColor"
                  :text-color="
                    item.stock_detail.prohibit_flg | prohibitFlgsTextColor
                  "
                >
                  {{ item.stock_detail.prohibit_flg | prohibitFlgsText }}
                </v-chip>
              </template>
              <template v-slot:item.price="{ item }">
                {{ $t("Global.money") }}
                {{ item.price }}
              </template>
              <template v-slot:item.production_date="{ item }">
                {{ item.production_date | formatDate }}
              </template>
              <template v-slot:item.expired_date="{ item }">
                {{ item.expired_date | formatDate }}
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="dialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="submit()">
            {{ $t("StockContainers.selectContainer.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import StockDetails from "@/api/stock_details";

export default {
  name: "SelectStockBatchDialog",

  props: {
    value: Boolean,
    label: String,
    currentItem: Object,
    stockId: Number,
  },

  components: {
    SearcherKeyword,
    SearcherStatus,
  },

  computed: {
    stockPositionBatchItems() {
      return this.stockPositionBatchs.filter(
        (batch) =>
          ((this.stockBatchCodeKeyword &&
            batch.stock_batch_code.indexOf(this.stockBatchCodeKeyword) != -1) ||
            !this.stockBatchCodeKeyword) &&
          ((this.stockBatchStatus.length &&
            this.stockBatchStatus.find((s) => s == batch.expired_flg) !=
              undefined) ||
            !this.stockBatchStatus.length)
      );
    },
    stockBatchHeaders() {
      var headers = [
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.material"
          ),
          align: "center",
          sortable: false,
          value: "MaterialDescription",
        },
      ];
      if (this.mode == "new") {
        headers.push({
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.position"
          ),
          align: "center",
          sortable: false,
          value: "PositionDescription",
        });
      }
      headers.push(
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.stock_batch_code"
          ),
          align: "center",
          sortable: false,
          value: "stock_batch_code",
        },
        {
          text: i18n.t("MovePositionOrder.StockBatchDialog.DetailFieds.price"),
          align: "center",
          sortable: false,
          value: "price",
        },
        {
          text: i18n.t("MovePositionOrder.StockBatchDialog.DetailFieds.stock_current_unit"),
          align: "center",
          sortable: false,
          value: "stock_current_unit",
        },
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.production_date"
          ),
          align: "center",
          sortable: false,
          value: "production_date",
        },
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.expired_date"
          ),
          align: "center",
          sortable: false,
          value: "expired_date",
        }
      );
      return headers;
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountUser"]),
  },

  data: () => ({
    dialog: false,
    stockPositionBatchs: [],
    seacherStockBatchCodeKeyword: "",
    stockBatchCodeKeyword: "",
    stockBatchStatus: [0, 1],
    showSelected: [],
    searchStockBatchs: [],
  }),

  methods: {
    getBatchData() {
      if (this.currentItem) {
        StockDetails.fetch({
          stock_ids: this.stockId,
          material_ids: this.currentItem.material_id,
          status: [0, 2],
          prohibit_flgs: [0],
        }).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stockPositionBatchs = response.data.stock_details.map((batch) => {
                const MaterialDescription = i18n.t(
                  this.settings
                    ? this.settings.material_name_display_type == 4
                      ? "Material.nameWithCodeAndStandard"
                      : this.settings.material_name_display_type == 3
                      ? "Material.materialNameWithCodeAndStandard"
                      : this.settings.material_name_display_type == 2
                      ? "Material.materialNameWithCode"
                    : "Material.materialName"
                  : "Material.materialName",
                  [
                    batch.material.material_code,
                    batch.material.material_name,
                    batch.material.standard_name ? (batch.material.standard_name.length > 12 ? batch.material.standard_name.slice(0, 12) + "......" : batch.material.standard_name) : "",

                  ]
                );
                return Object.assign({}, batch, {MaterialDescription});
              });
              this.stockPositionBatchs.forEach((batch) => {
                if (this.currentItem.stock_detail_ids && this.currentItem.stock_detail_ids.includes(batch.id)) {
                  this.showSelected.push(batch)
                }
              })
            }
          }.bind(this)
        );
      }
    },
    submit() {
      var showSelectedId = [];
      this.showSelected.map((selected) => {
        showSelectedId.push(selected.id);
      });

      this.$emit("stockBatchSeleted", this.showSelected);
      this.dialog = false;
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = true;
          this.getBatchData()
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.showSelected = [];
        }
      },
    },
    currentItem: {
      handler() {

      },
    },
    seacherStockBatchCodeKeyword: {
      handler() {
        this.stockBatchCodeKeyword = this.seacherStockBatchCodeKeyword;
      },
    },
    stockPositionBatchs: {
      handler() {
        this.stockPositionBatchs.forEach((batch) => {
          if (new Date(batch.expired_date).getTime() < new Date().getTime()) {
            batch.expired_flg = 1;
          } else {
            batch.expired_flg = 0;
          }
        });
      },
    },
  },
};
</script>